import {mockData, sizeMap} from "./mockData.js";
import getEnv from "../helpers/getEnv.js";

function fetchProductData(id, size, callback) {
  if (getEnv() === "development") {
    const relatedId = sizeMap[id] && sizeMap[id][size];
    const targetId = relatedId || id;
    const response = mockData.find(item => targetId === item.id);
    if (response) {
      setTimeout(callback(response), 100);
    } else {
      setTimeout(callback({ error: "Product not found" }), 100);
    }
  } else {
    const url = document.location.href;
    let xhr = new XMLHttpRequest();
    xhr.open("POST", url, true);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    xhr.setRequestHeader(
      "Accept",
      "application/json, text/javascript, */*; q=0.01"
    );
    xhr.onreadystatechange = function() {
      if (xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {
        callback(JSON.parse(xhr.response).data);
      }
    };
    xhr.send(`ms2c_action=get/product&id=${id}&options[size]=${size}`);
  }
}

export default fetchProductData;



// WEBPACK FOOTER //
// ./src/js/api/fetchProductData.js